export default __webpack_public_path__ + "static/media/assets-fonts-2_00.3fb3d9f6.jpg";